export interface PageConfig {
  apiBaseUrl: string;
  loginUrl: string;
}

function getEnvVariable(name: string, description: string): string {
  //! can be used only on serverside (on client side variable will always be undefined)
  const variable = process.env[name];

  if (!variable) throw new Error(`Please provide the ${description} as environment variable ${name}`);
  return variable;
}

export const ConfigHelper = {
  getEnvVariable,
};
